'use client';

import { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import HamburgerIcon from 'public/images/sidebar-hamburger.svg';

import s from './index.module.scss';

import { Image } from '#/components/custom-image-loader';
import { isNavItemActive, NAV_ITEMS, normalizePathname } from '#/components/top-level-shell';

export function MobileNavMenu() {
  const pathname = normalizePathname(usePathname());
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={s.mobileNavWrap}>
      <button
        aria-expanded={isOpen}
        aria-haspopup='menu'
        aria-label='Open navigation menu'
        className={s.mobileMenuButton}
        type='button'
        onClick={() => setIsOpen((current) => !current)}
      >
        <Image alt='' className={s.mobileMenuIcon} height={24} src={HamburgerIcon} aria-hidden />
      </button>

      {isOpen ? (
        <div className={s.mobileMenuPanel} role='menu'>
          {NAV_ITEMS.map((item) => {
            const isActive = isNavItemActive(pathname, item.href);

            return (
              <Link
                aria-current={isActive ? 'page' : undefined}
                className={s.mobileMenuItem}
                data-active={isActive}
                href={item.href}
                key={item.href}
                role='menuitem'
                onClick={() => setIsOpen(false)}
              >
                <Image
                  alt=''
                  className={s.mobileMenuItemIcon}
                  height={18}
                  src={item.icon}
                  aria-hidden
                />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
